<app-update-indicator
  *ngIf="is3dUpdateNeeded"
  (updateEvent)="updateViewer()"
></app-update-indicator>

<div id="viewerContent"></div>
